import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import * as _ from 'lodash';
import {NavigationService} from "./navigation.service";
import {Router} from "@angular/router";
import {UserService} from "./user.service";
import {TrackableEntity} from "../model/trackable-entity.model";
import {CommonService} from "./common.service";

export abstract class TrackableEntityActionService<T extends TrackableEntity> {

  protected _savedEventsId: number[] = [];
  protected _changeSavedEvents = new BehaviorSubject<{
    entity: T,
    favorite: boolean,
    totFavorite: number
  }>(undefined);

  constructor(protected http: HttpClient,
              protected navigationService: NavigationService,
              protected router: Router,
              protected userService: UserService,
              protected commonService: CommonService,
              protected baseUrl: string) {
  }

  get changeSavedEvents() {
    return this._changeSavedEvents.asObservable();
  }

  putCountCalendar(entity: T, addCalendar: number = 1) {
    this.countCalendarFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({addCalendar}, entity));
  }

  putCountOpen(entity: T, countOpen: number = 1) {
    this.countOpenFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countOpen}, entity));
  }

  putCountCall(entity: T, countCall: number = 1) {
    this.countCallFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countCall}, entity));
  }

  putCountWhatsapp(entity: T, countWhatsapp: number = 1) {
    this.countWhatsappFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countWhatsapp}, entity));
  }

  putCountNavigate(entity: T, countNavigate: number = 1) {
    this.countNavigateFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countNavigate}, entity));
  }

  putCountInstagram(entity: T, countInstagram: number = 1) {
    this.countInstagramFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countInstagram}, entity));
  }

  putCountFacebook(entity: T, countFacebook: number = 1) {
    this.countFacebookFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countFacebook}, entity));
  }

  putCountExternalLink(entity: T, countExternalLink: number = 1) {
    this.countExternalLinkFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countExternalLink}, entity));
  }

  putCountShare(entity: T, countShare: number = 1) {
    this.countShareFB(entity);
    return this.http.put<T>(`${this.baseUrl}`, this._addEventToRequest({countShare}, entity));
  }

  toggleFavorite(entity: T) {

    this.navigationService.navigationAfterLogin = [this.router.url];

    return new Observable((observer) => {

      if (this.userService.user?.isGuest) {
        this.navigationService.openPagesModal('register_feature');
        return; // interrompi qui
      }

      entity.metrics.currentUserFavorite = !entity.metrics.currentUserFavorite;

      this.toggleSavedEvent(entity);

      const favorite: boolean = entity.metrics.currentUserFavorite;

      if (favorite) {
        entity.metrics.totFavorite += 1;
        this._savedEventsId.push(entity.id);
      } else {
        entity.metrics.totFavorite -= 1;
        _.remove(this._savedEventsId, item => item == entity.id);
      }

      // Effettua l'update sul backend
      this.http.put<T>(
        `${this.baseUrl}`,
        this._addEventToRequest({favorite}, entity)
      ).subscribe({
        next: () => {
          this._changeSavedEvents.next({entity, favorite, totFavorite: entity.metrics.totFavorite});
          observer.next();
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
          observer.complete();
        }
      });
    });

  }

  private _addEventToRequest(payload: any, entity: T) {
    return {
      ...payload,
      entity: {id: entity.id}
    };
  }

  private async toggleSavedEvent(entity: T) {

    const entityId = entity.id;

    //Rimuovo l'entityo
    if (entity.metrics.currentUserFavorite) {
      _.remove(this._savedEventsId, item => item == entityId);
    } else {

      //Aggiungo ò'entityo
      this._savedEventsId.push(entityId);
      this.commonService.showToast('Aggiunto ai preferiti');

      this.toggleFavoriteFB(entity);
    }

    if (entity.metrics.currentUserFavorite) {
      this.commonService.showToast('Aggiunto ai preferiti');
    } else {
      this.commonService.showToast('Rimosso dai preferiti');
    }

  }

  public abstract countCalendarFB(entity: T);
  public abstract countOpenFB(entity: T);
  public abstract countCallFB(entity: T);
  public abstract countWhatsappFB(entity: T);
  public abstract countNavigateFB(entity: T);
  public abstract countInstagramFB(entity: T);
  public abstract countFacebookFB(entity: T);
  public abstract countExternalLinkFB(entity: T);
  public abstract countShareFB(entity: T);
  public abstract toggleFavoriteFB(entity: T);

}
